import { lazy, useEffect } from "react"
import { createHashRouter } from "react-router-dom"
import {
    DisclaimerPage,
    EULAPage,
    PrivacyPolicyPage,
    TermsOfUsePage,
} from "@/pages/terms-and-policy/Terms"
import { RoutesPath } from "@/router/config"
import { msalInstance } from "@/index"
import { loginRequest } from "@/config/authConfig"

let loginTriggered = false

const AutoLogin = () => {
    useEffect(() => {
        if (loginTriggered) return
        loginTriggered = true
        msalInstance.loginRedirect(loginRequest).catch(console.error)
    }, [])
    return null
}

const MobileOopsPage = lazy(() => import("@/pages/mobileOops"))

const unauthenticatedRouter = createHashRouter([
    {
        path: RoutesPath.TermsOfUse,
        element: <TermsOfUsePage />,
    },
    {
        path: RoutesPath.TermsOfService,
        element: <TermsOfUsePage />,
    },
    {
        path: RoutesPath.PrivacyPolicy,
        element: <PrivacyPolicyPage />,
    },
    {
        path: RoutesPath.Disclaimer,
        element: <DisclaimerPage />,
    },
    {
        path: RoutesPath.EULA,
        element: <EULAPage />,
    },
    {
        path: "/mobile-oops",
        element: <MobileOopsPage />,
    },
    {
        path: "*",
        element: <AutoLogin />,
    },
])

export default unauthenticatedRouter
